'use client';

import { Suspense } from 'react';
import Loading from '@/components/Loading';

interface EntryServiceLayoutProps {
    children: React.ReactNode;
}

export default function EntryServiceLayout({ children }: EntryServiceLayoutProps) {
    return (
        <>
            <div className="flex flex-col justify-start items-start w-full h-dvh overflow-y-scroll overflow-x-hidden">
                <Suspense fallback={<Loading />}>{children}</Suspense>
            </div>
        </>
    );
}
